import { addLogEntry } from './debugLog'
import { renderCrashScreen } from './errorStates'

let installed = false
let crashShown = false

/** Catch pure JS crashes (uncaught errors + unhandled rejections), record them
 *  in the debug buffer, and — only if the map never came up — show a minimal
 *  crash screen so the user gets a code + copy button instead of a white page.
 *  Idempotent; no `capture`, so failed tile/image loads are NOT treated as crashes. */
export function installCrashGuard(app: HTMLElement): void {
  if (installed) return
  installed = true
  window.addEventListener('error', (e) => record(e.message, e.error?.stack, app))
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason as { message?: string; stack?: string } | undefined
    record(String(reason?.message ?? reason ?? 'unhandledrejection'), reason?.stack, app)
  })
}

function record(message: string, stack: string | undefined, app: HTMLElement): void {
  addLogEntry('unknown', 0, message || 'Unknown error', undefined, (stack ?? '').slice(0, 2000))
  if (crashShown) return
  if (app.querySelector('#map')) return // map is up — don't tear down a working session
  crashShown = true
  renderCrashScreen(app)
}
